import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import Loading from "../../common/Loading";
import { PTOREQUEST_COLUMNS, generatePtoColumnsMobile } from "./columns";
import ResponsiveDataComponent from "../../common/ResponsiveDataComponent";

import { formatDate } from "../../../helpers/date";

const PtoRequestList = ({
  data,
  loading,
  page,
  pageSize,
  onPageSizeChange,
  onPageChange,
  onRowClick,
  isMobile = false
}) => {
  const columns = !isMobile
    ? PTOREQUEST_COLUMNS
    : [
        {
          Header: "Start Date",
          accessor: "start_date",
          Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--")
        },
        {
          Header: "End Date",
          accessor: "end_date",
          Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--")
        }
      ];

  const generateMobileCols = (row) => (
    <ResponsiveDataComponent data={generatePtoColumnsMobile(row)} />
  );

  if (loading) {
    return (
      <div className="loading">
        <Loading />
      </div>
    );
  }
  const props = {
    getTdProps: (state, rowInfo, column) => {
      if (!column.expander) {
        return {
          onClick: () => column.id !== "_id" && onRowClick(rowInfo)
        };
      }
      return {};
    }
  };
  return (
    <div className="content-wrapper">
      <ReactTable
        {...props}
        className="-highlight"
        data={data}
        columns={columns}
        LoadingComponent={() => <Loading active={loading} />}
        showPageSizeOptions={!isMobile}
        onPageSizeChange={onPageSizeChange}
        page={page}
        onPageChange={onPageChange}
        pageSize={Math.min(data.length, pageSize)}
        defaultSorted={[
          {
            id: "created_on",
            desc: true
          }
        ]}
        SubComponent={isMobile ? generateMobileCols : null}
      />
    </div>
  );
};
PtoRequestList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onRowClick: PropTypes.func,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  isMobile: PropTypes.bool
};

export default PtoRequestList;
